module.exports = "http://cdn.realive.com.ua/src/views/games/other/images/maps/map_4.png";